import { useFieldContext } from '../lib/formContext';
import { getFormFieldInputId } from '../lib/getFormFieldInputId';
import { FormLabel, FormLabelProps } from './FormLabel';

export interface FormLabelControlProps extends FormLabelProps {}

export const FormLabelControl = (props: FormLabelControlProps) => {
  const { htmlFor: htmlForProp, ...other } = props;
  const field = useFieldContext();

  const htmlFor = htmlForProp ?? getFormFieldInputId(field);

  return <FormLabel {...other} htmlFor={htmlFor} />;
};
